"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("$translate", function ($q, $http) {
  var url, lang, translationMap;
  var translate = function translate(translationKey, translationParams) {
    var translationValue = translationMap != null && translationMap[translationKey];
    if (translationValue != null) {
      if (translationParams != null) {
        return supplant(translationValue, translationParams);
      } else {
        return translationValue;
      }
    } else {
      return "?" + translationKey + "?";
    }
  };
  translate.init = function (options) {
    url = options.url;
    lang = options.lang;

    // TODO : add noDateParsing flag
    return $http.get(url, {
      params: {
        lang: lang
      },
      noDateParsing: true
    }).then(function (response) {
      translationMap = response.data;
      console.log(_.size(translationMap) + ' traductions chargées');
    });
  };
  var SUPPLANT_REGEXP = /{{([^{}]*)}}/g;
  function supplant(template, values) {
    return template.replace(SUPPLANT_REGEXP, function (a, b) {
      var r = values[b];
      return r != null ? r : a;
    });
  }
  _.extend(translate, {
    exist: function exist(translationKey) {
      return translationMap != null && translationMap[translationKey] != null;
    }
  });
  return translate;
});
ngModule.filter("translate", function ($translate) {
  return function translateFilter(translationKey, translationParams) {
    return $translate(translationKey, translationParams);
  };
});
ngModule.directive("translate", function ($translate, $sanitize) {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      var translationKey = $.trim($el.text());
      var translation = $translate(translationKey);
      $el.html($sanitize(translation));
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/i18n/$translate.js
// module id = 2714
// module chunks = 13